/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationQuantityUsageDto } from './CreateEnumerationQuantityUsageDto';
import {
    CreateEnumerationQuantityUsageDtoFromJSON,
    CreateEnumerationQuantityUsageDtoFromJSONTyped,
    CreateEnumerationQuantityUsageDtoToJSON,
} from './CreateEnumerationQuantityUsageDto';
import type { QuantityUsageType } from './QuantityUsageType';
import {
    QuantityUsageTypeFromJSON,
    QuantityUsageTypeFromJSONTyped,
    QuantityUsageTypeToJSON,
} from './QuantityUsageType';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface CreateUpdateEnumerationQuantityDto
 */
export interface CreateUpdateEnumerationQuantityDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {StateOfUse}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {QuantityUsageType}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    quantityUsageType?: QuantityUsageType;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {CreateEnumerationQuantityUsageDto}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    setupUsage?: CreateEnumerationQuantityUsageDto;
    /**
     * 
     * @type {CreateEnumerationQuantityUsageDto}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    evaluationUsage?: CreateEnumerationQuantityUsageDto;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    $type?: CreateUpdateEnumerationQuantityDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUpdateEnumerationQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateUpdateEnumerationQuantityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateUpdateEnumerationQuantityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUpdateEnumerationQuantityDtoTypeEnum = typeof CreateUpdateEnumerationQuantityDtoTypeEnum[keyof typeof CreateUpdateEnumerationQuantityDtoTypeEnum];



/**
 * Check if a given object implements the CreateUpdateEnumerationQuantityDto interface.
 */
export function instanceOfCreateUpdateEnumerationQuantityDto(value?: unknown): value is CreateUpdateEnumerationQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUpdateEnumerationQuantityDtoTypeEnum)[0];
}

export function CreateUpdateEnumerationQuantityDtoFromJSON(json: any): CreateUpdateEnumerationQuantityDto {
    return CreateUpdateEnumerationQuantityDtoFromJSONTyped(json, false);
}

export function CreateUpdateEnumerationQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateEnumerationQuantityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'quantityUsageType': json['quantityUsageType'] == null ? undefined : QuantityUsageTypeFromJSON(json['quantityUsageType']),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'setupUsage': json['setupUsage'] == null ? undefined : CreateEnumerationQuantityUsageDtoFromJSON(json['setupUsage']),
        'evaluationUsage': json['evaluationUsage'] == null ? undefined : CreateEnumerationQuantityUsageDtoFromJSON(json['evaluationUsage']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateUpdateEnumerationQuantityDtoToJSON(value?: CreateUpdateEnumerationQuantityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'isAvailable': value['isAvailable'],
        'state': StateOfUseToJSON(value['state']),
        'quantityUsageType': QuantityUsageTypeToJSON(value['quantityUsageType']),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'setupUsage': CreateEnumerationQuantityUsageDtoToJSON(value['setupUsage']),
        'evaluationUsage': CreateEnumerationQuantityUsageDtoToJSON(value['evaluationUsage']),
        '$type': value['$type'],
    });
}

